webpackJsonp([246384609461072],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CasestudyNodeFragment = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:hover .card {\n    position: relative;\n    top: -1px;\n  }\n'], ['\n  &:hover .card {\n    position: relative;\n    top: -1px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  &.ui.menu {\n    margin-top: .3em;\n    margin-bottom: 2em;\n    .container {\n      justify-content: center;\n    }\n    .item {\n      opacity: 0.3;\n      &:hover, &:active {\n        opacity: 1;\n      }\n      &:active {\n        color: ', ';\n      }\n    }\n  }\n'], ['\n  &.ui.menu {\n    margin-top: .3em;\n    margin-bottom: 2em;\n    .container {\n      justify-content: center;\n    }\n    .item {\n      opacity: 0.3;\n      &:hover, &:active {\n        opacity: 1;\n      }\n      &:active {\n        color: ', ';\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(94);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _tags = __webpack_require__(109);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CardLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	var PortfolioMenu = (0, _styledComponents2.default)(_semanticUiReact.Menu)(_templateObject2, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var PortfolioCard = function PortfolioCard(_ref) {
	  var casestudy = _ref.casestudy,
	      expand = _ref.expand;
	  var heroImage = casestudy.heroImage,
	      title = casestudy.title,
	      slug = casestudy.slug,
	      abstract = casestudy.abstract,
	      publishDate = casestudy.publishDate,
	      tags = casestudy.tags;
	
	
	  var formatDate = function formatDate(date) {
	    var objDate = new Date(date);
	    return objDate.toLocaleString('en', { month: 'short' }) + ' ' + objDate.toLocaleString('en', { year: 'numeric' });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      CardLink,
	      { to: '/portfolio/' + slug + '/' },
	      _react2.default.createElement(
	        _semanticUiReact.Card,
	        { raised: true, fluid: true },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: heroImage.sizes, backgroundColor: '#EEE' }),
	        expand && _react2.default.createElement(
	          _semanticUiReact.Card.Content,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Card.Header,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Meta,
	            null,
	            formatDate(publishDate)
	          ),
	          _react2.default.createElement(
	            _semanticUiReact.Card.Description,
	            null,
	            abstract.abstract.substr(0, 50)
	          )
	        )
	      )
	    ),
	    expand && _react2.default.createElement(_tags2.default, { items: tags })
	  );
	};
	
	var PortfolioGrid = function (_React$Component) {
	  _inherits(PortfolioGrid, _React$Component);
	
	  function PortfolioGrid() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PortfolioGrid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fullView: true
	    }, _this.handleViewToggle = function () {
	      return _this.setState({ fullView: !_this.state.fullView });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  PortfolioGrid.prototype.componentWillMount = function componentWillMount() {
	    var fullView = this.props.fullView;
	
	    if (typeof fullView != 'undefined') {
	      this.setState({ fullView: fullView });
	    }
	  };
	
	  PortfolioGrid.prototype.render = function render() {
	    var fullView = this.state.fullView;
	    var casestudies = this.props.casestudies;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        PortfolioMenu,
	        { secondary: true, icon: true, size: 'huge' },
	        _react2.default.createElement(
	          _semanticUiReact.Container,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Menu.Menu,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Menu.Item,
	              { name: 'Show/Hide Info', onClick: this.handleViewToggle },
	              _react2.default.createElement(_semanticUiReact.Icon, { name: 'block layout' }),
	              '\xA0\xA0',
	              fullView ? 'Hide' : 'View',
	              ' info'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { stackable: true, columns: 3 },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          null,
	          casestudies.map(function (_ref2) {
	            var casestudy = _ref2.node;
	            return _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              { key: casestudy.id },
	              _react2.default.createElement(PortfolioCard, { casestudy: casestudy, expand: fullView })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return PortfolioGrid;
	}(_react2.default.Component);
	
	var CasestudyNodeFragment = exports.CasestudyNodeFragment = '** extracted graphql fragment **';
	
	exports.default = PortfolioGrid;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  height: 100%;\n'], ['\n  flex: 1;\n  height: 100%;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 3.06em;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 0;\n'], ['\n  font-size: 3.06em;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 0;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(72);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _semanticUiReact = __webpack_require__(19);
	
	var _reactSemanticBooster = __webpack_require__(38);
	
	var _siteConfig = __webpack_require__(33);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _PortfolioGrid = __webpack_require__(165);
	
	var _PortfolioGrid2 = _interopRequireDefault(_PortfolioGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2);
	
	var Portfolio = function Portfolio(_ref) {
	  var data = _ref.data;
	
	  var casestudies = data.allContentfulCasestudy.edges;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Portfolio - ' + _siteConfig2.default.siteTitle
	      ),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Portfolio - ' + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement('meta', { property: 'og:url', content: _siteConfig2.default.siteUrl + '/portfolio/' })
	    ),
	    _react2.default.createElement(
	      _reactSemanticBooster.Block,
	      { spacer: { top: 0.7, bottom: 1 } },
	      _react2.default.createElement(
	        Title,
	        null,
	        'Portfolio'
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        casestudies && _react2.default.createElement(_PortfolioGrid2.default, { casestudies: casestudies })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Portfolio;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-950d3aef5fc45c04193c.js